<template>
  <div class="min-h-screen flex items-center justify-center bg-gray-100 py-12 px-4 sm:px-6 lg:px-8">
    <div class="max-w-md w-full space-y-8">
      <div class="text-center">
        <h2 class="mt-6 text-3xl font-extrabold text-gray-900">
          Admin
        </h2>
        <p class="mt-2 text-sm text-gray-600">
          Faça login para acessar o painel administrativo
        </p>
      </div>
      
      <!-- Error Message -->
      <div v-if="error" class="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded">
        {{ error }}
      </div>
      
      <!-- Success Message -->
      <div v-if="success" class="bg-green-50 border border-green-200 text-green-700 px-4 py-3 rounded">
        {{ success }}
      </div>
      
      <form class="mt-8 space-y-6" @submit.prevent="handleLogin">
        <div class="rounded-md shadow-sm -space-y-px">
          <div>
            <label for="email" class="sr-only">Email</label>
            <input
              id="email"
              v-model="email"
              name="email"
              type="email"
              required
              class="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-t-md focus:outline-none focus:ring-orange-500 focus:border-orange-500 focus:z-10 sm:text-sm"
              placeholder="Email"
            >
          </div>
          <div>
            <label for="password" class="sr-only">Senha</label>
            <input
              id="password"
              v-model="password"
              name="password"
              type="password"
              required
              class="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-b-md focus:outline-none focus:ring-orange-500 focus:border-orange-500 focus:z-10 sm:text-sm"
              placeholder="Senha"
            >
          </div>
        </div>
        
        <!-- reCAPTCHA widget -->
        <div v-if="recaptcha.isEnabled.value" class="flex justify-center">
          <div id="admin-recaptcha"></div>
        </div>

        <div>
          <button
            type="submit"
            :disabled="loading"
            class="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-orange-600 hover:bg-orange-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orange-500 disabled:opacity-50"
          >
            <span v-if="loading">Entrando...</span>
            <span v-else>Entrar</span>
          </button>
        </div>
        
        <div class="text-center">
          <router-link to="/forgot-password" class="text-sm text-orange-600 hover:text-orange-500">
            Esqueceu sua senha?
          </router-link>
        </div>
      </form>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { useAuthStore } from '@/stores'
import { useRecaptcha } from '@/composables/useRecaptcha'

const router = useRouter()
const authStore = useAuthStore()
const recaptcha = useRecaptcha('admin-recaptcha')

const email = ref('')
const password = ref('')
const loading = ref(false)
const error = ref('')
const success = ref('')

const handleLogin = async () => {
  loading.value = true
  error.value = ''
  success.value = ''
  
  try {
    // Verifica reCAPTCHA se habilitado
    if (recaptcha.isEnabled.value && !recaptcha.token.value) {
      error.value = 'Por favor, complete a verificação reCAPTCHA.'
      loading.value = false
      return
    }
    
    const result = await authStore.login(email.value, password.value, recaptcha.token.value)
    
    if (result.success) {
      success.value = 'Login realizado com sucesso!'
      setTimeout(() => {
        router.push('/admin')
      }, 300)
    } else {
      error.value = result.error || 'Erro ao fazer login'
      recaptcha.reset()
    }
  } catch (e: any) {
    error.value = e.message || 'Erro ao fazer login'
    recaptcha.reset()
  }
  
  loading.value = false
}
</script>
